import { api } from "../lib/api";

export const list = (prospectId) =>
  api.get(`/prospects/${prospectId}/opportunities`).then((response) => response.data);

export const create = (prospectId, payload) =>
  api.post(`/prospects/${prospectId}/opportunities`, payload).then((response) => response.data);

export const get = (opportunityId) =>
  api.get(`/prospect-opportunities/${opportunityId}`).then((response) => response.data);

export const update = (opportunityId, payload) =>
  api.put(`/prospect-opportunities/${opportunityId}`, payload).then((response) => response.data);

export const remove = (opportunityId) =>
  api.delete(`/prospect-opportunities/${opportunityId}`).then((response) => response.data);

export const duplicate = (opportunityId) =>
  api.post(`/prospect-opportunities/${opportunityId}/duplicate`).then((response) => response.data);


// ACTA_PIPELINE_OPPORTUNITIES_API_V1
export const pipelineBoard = ({
  ownerUserId = "",
  ownerRole = "",
  dateFrom = "",
  dateTo = "",
} = {}) =>
  api
    .get("/prospect-opportunities/pipeline-board", {
      params: {
        owner_user_id: ownerUserId,
        owner_role: ownerRole,
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
    .then((response) => response.data);

// ACTA_PIPELINE_CONTACT_LOST_API_V1
export const markContactLost = (prospectId, payload) =>
  api.patch(
    `/prospects/${encodeURIComponent(prospectId)}/pipeline-contact-lost`,
    payload
  ).then((response) => response.data);

export const reactivateContact = (prospectId) =>
  api.patch(
    `/prospects/${encodeURIComponent(prospectId)}/pipeline-contact-reactivate`
  ).then((response) => response.data);

export const moveStage = (opportunityId, payload) =>
  api.patch(`/prospect-opportunities/${encodeURIComponent(opportunityId)}/stage`, payload).then((response) => response.data);

// ACTA_OPPORTUNITY_PAYMENT_AI_V8
export const submitFinalization = (opportunityId, payload) =>
  api.put(
    `/prospect-opportunities/${encodeURIComponent(opportunityId)}/finalization-submission`,
    payload
  ).then((response) => response.data);

export const validateOpportunityPayment = (opportunityId, payload) =>
  api.put(`/prospect-opportunities/${opportunityId}/payment-validation`, payload).then((r) => r.data);

// ACTA_OPPORTUNITY_QUOTE_PAYMENT_PROOF_V9
export const uploadPaymentProof = (opportunityId, file) => {
  const data = new FormData();
  data.append("file", file);
  return api.post(`/prospect-opportunities/${encodeURIComponent(opportunityId)}/payment-proof`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((response) => response.data);
};

export const paymentProofFileUrl = (opportunityId) =>
  `/api/prospect-opportunities/${encodeURIComponent(opportunityId)}/payment-proof/file`;
